/**
 * mwApp main module
 *
 * @namespace mwApp
 */

import 'angular'

import Acls from '../acls'
import Auth from '../auth'
import Channels from '../channels'
import Common from '../common'
import Devices from '../devices'
import Drm from '../drm'
import Home from '../home'
import LiveEvent from '../liveEvents'
import Localization from '../localization'
import Models from './models'
import Packages from '../packages'
import PartnerPrograms from '../partnerPrograms'
import Partners from '../partners'
import Preferences from '../preferences'
import Reports from '../reports'
import Sets from '../sets'
import Settings from '../settings'
import Services from '../services'
import Shows from '../shows'
import Streams from '../streams'
import Ssais from '../ssais'
import Subscribers from '../subscribers'
import VODs from '../vods'
import appConfig from './app.config'
import appKeyboardShortcuts from './app.shortcuts'

import appRun from './app.run'

import { env } from './app.directives'
import * as Sentry from '@sentry/browser'
import { Angular as AngularIntegration } from '@sentry/integrations'
require('ngclipboard')

// Make sure to call Sentry.init after importing AngularJS.
// You can also pass {angular: AngularInstance} to the Integrations.Angular() constructor.
Sentry.init({
  dsn: window.ENV.APP_SENTRY_DSN,
  integrations: [new AngularIntegration()],
  environment: window.ENV.APP_SENTRY_PRODMODE_ENABLED ? 'production' : 'dev'
})
export default
angular.module('mwApp', [
  Common.name, // must be first, because it contains dependencies to other vital modules
  Models.name,
  Auth.name,
  Acls.name,
  Channels.name,
  Devices.name,
  Drm.name,
  Ssais.name,
  Home.name,
  LiveEvent.name,
  Localization.name,
  Packages.name,
  PartnerPrograms.name,
  Partners.name,
  Preferences.name,
  Reports.name,
  Sets.name,
  Settings.name,
  Services.name,
  Shows.name,
  Streams.name,
  Subscribers.name,
  VODs.name,
  'ngclipboard',
  'ngSentry'
])
  .config(appConfig)
  .directive('env', env)
  .run(appKeyboardShortcuts)
  .run(appRun)

// load mimic in development mode
if (process.env.NODE_ENV === 'development') {
  require('mimic')
}
